<template>
  <el-dialog
          title="公告信息"
          :visible.sync="dialogVisible"
          @opened="dialogOpen"
          width="90vw"

  >
    <div class="el-dialog-div">
    <el-form
            ref="form"
            :model="form"
            label-width="100px"
            size="small"
    >
      <el-form-item
              prop="noticeTitle"
              label="公告标题"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.noticeTitle"></el-input>
      </el-form-item>
      <el-form-item
              prop="legal"
              label="告警对象"
      >
        <input type="checkbox" v-model="checked" v-on:click='check_All_Change22'> 全选

        <el-checkbox-group v-model="type_of_cost" @change="condition_inquire">
          <el-checkbox v-for="(item_type_of_cost,index) in item_type_of_costs" :label="item_type_of_cost.code" :key="item_type_of_cost.code">{{item_type_of_cost.label}}</el-checkbox>
        </el-checkbox-group>

      </el-form-item>
      <el-form-item
              prop="legal"
              label="公告内容"
      >

        <Editor v-model="form.content"  ref="mychild"/>


      </el-form-item>

      <el-form-item  v-if="formEdit">
        <el-button
                type="primary"
                :loading="loading"
                @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>
    </div>
  </el-dialog>

</template>
<style>
  .el-dialog-div {
    height: 60vh;
    overflow-x: hidden;
  }
</style>
<script>
  import * as noticeService from "@/api/sys/notice";
  import util from '@/libs/util.js'
  import  Editor from './Editor';
  export default {
    name: "payparameterEditForm",
    components: { Editor },
    props: {
      agent: Object,
      accuseVisible:Boolean,
      value: Boolean
    },
    data() {
      return {
        formEdit: true,
        accuseVisible2:true,
        loading: false,
        dialogVisible: false,
        form: {
          noticeTitle: "",
          content: ""
        },
        checked:false,
        type_of_cost : [],//用户选择的筛选条件
        item_type_of_costs : [{label : '一级代理',code : 0},{label : '二级代理',code : 1},{label : '三级代理',code : 2},{label : '商户',code : 4},{label : '小程序用户',code : 5}]
      };
    },
    watch: {
      value(val) {
        this.dialogVisible = val;
      },
      accuseVisible (newValue, oldValue) {
        console.log("-----"+newValue);
        this.accuseVisible2 = newValue;
      },

      dialogVisible(val) {
        this.$emit("input", val);
      }
    },
    methods: {
      dialogOpen() {
        this.$refs.form.resetFields();
        console.log("-----"+this.agent.noticeNote);
        if (this.agent.noticeId) {
          // userService.getUser(this.user.id).then(data => {
          let form = {};
          form.noticeTitle = this.agent.noticeTitle;

          var mycars=this.agent.noticeObject.substring(1,this.agent.noticeObject.length-1);
          if(mycars=='5'){
            this.type_of_cost=[5];
          }else  if(mycars=='0,1,2,4'){
            this.type_of_cost=[0,1,2,4];
          }else  if(mycars=='0,1,2,4,5'){
            this.type_of_cost=[0,1,2,4,5];
          }else  if(mycars=='4'){
            this.type_of_cost=[4];
          }

          this.$refs.mychild.content="";
          this.$refs.mychild.content=this.agent.noticeNote;


          this.form = form;
          // });
          this.formEdit =false;
        } else {
          this.formEdit =false;
          this.form = {};
        }
      },
      condition_inquire(){

      },
      check_All_Change22() {
        let that = this;
        /**
         * 将全部的信息添加到绑定的数组里面去，这样可以实现一个全选的效果
         * @type {any[]}
         */
        if (that.checked) { //实现反选
          that.type_of_cost = [];
        } else { //实现全选
          that.type_of_cost = that.item_type_of_costs.map((res) => {
            return res.code;
          });
        }
      },
      /**
       * @check_Nll_Change 全不选操作
       */
      check_Null_Change(){
        let that = this;
        that.type_of_cost = [];
      },
      saveUser() {
        this.$refs["form"].validate(valid => {
          if (valid) {
            this.loading = true;
            noticeService.saveNotice({ ...this.form,agentid:util.cookies.get('agentid'), noticeId:this.agent.noticeId,type_of_cost:this.type_of_cost})
                    .then(data => {
                      this.loading = false;
                      this.dialogVisible = false;
                      this.$emit("submit");
                    });
          } else {
            return false;
          }
        });
      },
      close() {
        this.$refs["form"].resetFields();
        this.dialogVisible = false;
      }
    }
  };
</script>

